import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert,
  Table, TableHead, TableRow, TableCell, TableBody, Chip, CircularProgress, Box,
} from '@mui/material';
import { quizService } from './quizService';

export default function AdminResultsDialog({ quizId, pass, onClose }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    quizService.adminResults(quizId, pass).then(setRows).catch((e) => setError(e.message));
  }, [quizId, pass]);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Attempts</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {!rows && !error && <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress /></Box>}
        {rows && rows.length === 0 && <Alert severity="info">No attempts yet.</Alert>}
        {rows && rows.length > 0 && (
          <Table size="small">
            <TableHead><TableRow>
              <TableCell>Name</TableCell><TableCell>Score</TableCell>
              <TableCell>Result</TableCell><TableCell>When</TableCell>
            </TableRow></TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{r.taker_name}</TableCell>
                  <TableCell>{r.score}/{r.max_score}</TableCell>
                  <TableCell>{r.passed === null ? '—' : <Chip size="small" color={r.passed ? 'success' : 'error'} label={r.passed ? 'Pass' : 'Fail'} />}</TableCell>
                  <TableCell>{r.completed_at ? new Date(r.completed_at).toLocaleString() : ''}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
  );
}
